import { toURLSearchParams } from '@wix/sdk-runtime/rest-modules';
import { transformSDKFloatToRESTFloat } from '@wix/sdk-runtime/transformations/float';
import { transformRESTFloatToSDKFloat } from '@wix/sdk-runtime/transformations/float';
import { transformSDKTimestampToRESTTimestamp } from '@wix/sdk-runtime/transformations/timestamp';
import { transformRESTTimestampToSDKTimestamp } from '@wix/sdk-runtime/transformations/timestamp';
import { transformSDKFieldMaskToRESTFieldMask } from '@wix/sdk-runtime/transformations/field-mask';
import { transformPaths } from '@wix/sdk-runtime/transformations/transform-paths';
import { resolveUrl } from '@wix/sdk-runtime/rest-modules';
import { ResolveUrlOpts } from '@wix/sdk-runtime/rest-modules';
import { RequestOptionsFactory } from '@wix/sdk-types';

function resolveWixTableReservationsExperienceV1ExperiencesServiceUrl(
  opts: Omit<ResolveUrlOpts, 'domainToMappings'>
) {
  const domainToMappings = {
    'manage._base_domain_': [
      {
        srcPath: '/_api/experiences',
        destPath: '',
      },
      {
        srcPath: '/_api/table-reservations/experiences',
        destPath: '',
      },
    ],
    'bo._base_domain_': [
      {
        srcPath: '/_api/table-reservations/experiences',
        destPath: '',
      },
    ],
    'wixbo.ai': [
      {
        srcPath: '/_api/table-reservations/experiences',
        destPath: '',
      },
    ],
    'wix-bo.com': [
      {
        srcPath: '/_api/table-reservations/experiences',
        destPath: '',
      },
    ],
    'editor._base_domain_': [
      {
        srcPath: '/_api/table-reservations/experiences',
        destPath: '',
      },
    ],
    'blocks._base_domain_': [
      {
        srcPath: '/_api/table-reservations/experiences',
        destPath: '',
      },
    ],
    'create.editorx': [
      {
        srcPath: '/_api/table-reservations/experiences',
        destPath: '',
      },
    ],
    'dev._base_domain_': [
      {
        srcPath: '/_api/table-reservations/experiences',
        destPath: '',
      },
    ],
    'apps._base_domain_': [
      {
        srcPath: '/_api/table-reservations/experiences',
        destPath: '',
      },
    ],
    'www.wixapis.com': [
      {
        srcPath: '/table-reservations/experiences',
        destPath: '',
      },
    ],
    '*.dev.wix-code.com': [
      {
        srcPath: '/_api/table-reservations/experiences',
        destPath: '',
      },
    ],
    'www._base_domain_': [
      {
        srcPath: '/_api/table-reservations/experiences',
        destPath: '',
      },
    ],
    'editor.wixapps.net': [
      {
        srcPath: '/_api/table-reservations/experiences',
        destPath: '',
      },
    ],
    _: [
      {
        srcPath: '/_api/table-reservations/experiences',
        destPath: '',
      },
    ],
  };

  return resolveUrl(Object.assign(opts, { domainToMappings }));
}

const PACKAGE_NAME = '@wix/auto_sdk_table-reservations_experiences';

/** Creates an experience. */
export function createExperience(payload: object): RequestOptionsFactory<any> {
  function __createExperience({ host }: any) {
    const serializedData = transformPaths(payload, [
      {
        transformFn: transformSDKTimestampToRESTTimestamp,
        paths: [
          { path: 'experience.createdDate' },
          { path: 'experience.updatedDate' },
          {
            path: 'experience.configuration.displayInfo.richContent.metadata.createdTimestamp',
          },
          {
            path: 'experience.configuration.displayInfo.richContent.metadata.updatedTimestamp',
          },
        ],
      },
      {
        transformFn: transformSDKFloatToRESTFloat,
        paths: [
          {
            path: 'experience.configuration.displayInfo.richContent.nodes.buttonData.styles.background.gradient.centerX',
          },
          {
            path: 'experience.configuration.displayInfo.richContent.nodes.buttonData.styles.background.gradient.centerY',
          },
          {
            path: 'experience.configuration.displayInfo.richContent.nodes.buttonData.styles.background.gradient.stops.position',
          },
          {
            path: 'experience.configuration.displayInfo.richContent.nodes.buttonData.styles.backgroundHover.gradient.centerX',
          },
          {
            path: 'experience.configuration.displayInfo.richContent.nodes.buttonData.styles.backgroundHover.gradient.centerY',
          },
          {
            path: 'experience.configuration.displayInfo.richContent.nodes.buttonData.styles.backgroundHover.gradient.stops.position',
          },
          {
            path: 'experience.configuration.displayInfo.richContent.nodes.galleryData.items.image.media.duration',
          },
          {
            path: 'experience.configuration.displayInfo.richContent.nodes.galleryData.items.video.media.duration',
          },
          {
            path: 'experience.configuration.displayInfo.richContent.nodes.galleryData.items.video.thumbnail.duration',
          },
          {
            path: 'experience.configuration.displayInfo.richContent.nodes.galleryData.options.item.ratio',
          },
          {
            path: 'experience.configuration.displayInfo.richContent.nodes.imageData.image.duration',
          },
          {
            path: 'experience.configuration.displayInfo.richContent.nodes.mapData.mapSettings.lat',
          },
          {
            path: 'experience.configuration.displayInfo.richContent.nodes.mapData.mapSettings.lng',
          },
          {
            path: 'experience.configuration.displayInfo.richContent.nodes.pollData.poll.image.duration',
          },
          {
            path: 'experience.configuration.displayInfo.richContent.nodes.pollData.poll.options.image.duration',
          },
          {
            path: 'experience.configuration.displayInfo.richContent.nodes.pollData.design.poll.background.image.duration',
          },
          {
            path: 'experience.configuration.displayInfo.richContent.nodes.appEmbedData.image.duration',
          },
          {
            path: 'experience.configuration.displayInfo.richContent.nodes.videoData.video.duration',
          },
          {
            path: 'experience.configuration.displayInfo.richContent.nodes.videoData.thumbnail.duration',
          },
          {
            path: 'experience.configuration.displayInfo.richContent.nodes.audioData.audio.duration',
          },
          {
            path: 'experience.configuration.displayInfo.richContent.nodes.audioData.coverImage.duration',
          },
          {
            path: 'experience.configuration.displayInfo.richContent.nodes.layoutData.backgroundImage.media.duration',
          },
          {
            path: 'experience.configuration.displayInfo.richContent.nodes.layoutData.backdropImage.media.duration',
          },
          {
            path: 'experience.configuration.displayInfo.richContent.nodes.layoutData.background.gradient.centerX',
          },
          {
            path: 'experience.configuration.displayInfo.richContent.nodes.layoutData.background.gradient.centerY',
          },
          {
            path: 'experience.configuration.displayInfo.richContent.nodes.layoutData.background.gradient.stops.position',
          },
          {
            path: 'experience.configuration.displayInfo.richContent.nodes.layoutData.backdrop.gradient.centerX',
          },
          {
            path: 'experience.configuration.displayInfo.richContent.nodes.layoutData.backdrop.gradient.centerY',
          },
          {
            path: 'experience.configuration.displayInfo.richContent.nodes.layoutData.backdrop.gradient.stops.position',
          },
          {
            path: 'experience.configuration.displayInfo.richContent.nodes.shapeData.shape.duration',
          },
          {
            path: 'experience.configuration.displayInfo.richContent.nodes.cardData.background.gradient.centerX',
          },
          {
            path: 'experience.configuration.displayInfo.richContent.nodes.cardData.background.gradient.centerY',
          },
          {
            path: 'experience.configuration.displayInfo.richContent.nodes.cardData.background.gradient.stops.position',
          },
          {
            path: 'experience.configuration.displayInfo.richContent.nodes.cardData.backgroundImage.media.duration',
          },
          {
            path: 'experience.configuration.displayInfo.richContent.nodes.tocData.fontSize',
          },
          {
            path: 'experience.configuration.displayInfo.richContent.nodes.tocData.itemSpacing',
          },
          {
            path: 'experience.configuration.displayInfo.richContent.nodes.smartBlockCellData.shape.duration',
          },
        ],
      },
    ]);
    const metadata = {
      entityFqdn: 'wix.table_reservations.v1.experience',
      method: 'POST' as any,
      methodFqn:
        'wix.table_reservations.experience.v1.ExperiencesService.CreateExperience',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveWixTableReservationsExperienceV1ExperiencesServiceUrl({
        protoPath: '/v1/experiences',
        data: serializedData,
        host,
      }),
      data: serializedData,
      transformResponse: (payload: any) =>
        transformPaths(payload, [
          {
            transformFn: transformRESTTimestampToSDKTimestamp,
            paths: [
              { path: 'experience.createdDate' },
              { path: 'experience.updatedDate' },
              {
                path: 'experience.configuration.displayInfo.richContent.metadata.createdTimestamp',
              },
              {
                path: 'experience.configuration.displayInfo.richContent.metadata.updatedTimestamp',
              },
            ],
          },
          {
            transformFn: transformRESTFloatToSDKFloat,
            paths: [
              {
                path: 'experience.configuration.displayInfo.richContent.nodes.buttonData.styles.background.gradient.centerX',
              },
              {
                path: 'experience.configuration.displayInfo.richContent.nodes.buttonData.styles.background.gradient.centerY',
              },
              {
                path: 'experience.configuration.displayInfo.richContent.nodes.buttonData.styles.background.gradient.stops.position',
              },
              {
                path: 'experience.configuration.displayInfo.richContent.nodes.buttonData.styles.backgroundHover.gradient.centerX',
              },
              {
                path: 'experience.configuration.displayInfo.richContent.nodes.buttonData.styles.backgroundHover.gradient.centerY',
              },
              {
                path: 'experience.configuration.displayInfo.richContent.nodes.buttonData.styles.backgroundHover.gradient.stops.position',
              },
              {
                path: 'experience.configuration.displayInfo.richContent.nodes.galleryData.items.image.media.duration',
              },
              {
                path: 'experience.configuration.displayInfo.richContent.nodes.galleryData.items.video.media.duration',
              },
              {
                path: 'experience.configuration.displayInfo.richContent.nodes.galleryData.items.video.thumbnail.duration',
              },
              {
                path: 'experience.configuration.displayInfo.richContent.nodes.galleryData.options.item.ratio',
              },
              {
                path: 'experience.configuration.displayInfo.richContent.nodes.imageData.image.duration',
              },
              {
                path: 'experience.configuration.displayInfo.richContent.nodes.mapData.mapSettings.lat',
              },
              {
                path: 'experience.configuration.displayInfo.richContent.nodes.mapData.mapSettings.lng',
              },
              {
                path: 'experience.configuration.displayInfo.richContent.nodes.pollData.poll.image.duration',
              },
              {
                path: 'experience.configuration.displayInfo.richContent.nodes.pollData.poll.options.image.duration',
              },
              {
                path: 'experience.configuration.displayInfo.richContent.nodes.pollData.design.poll.background.image.duration',
              },
              {
                path: 'experience.configuration.displayInfo.richContent.nodes.appEmbedData.image.duration',
              },
              {
                path: 'experience.configuration.displayInfo.richContent.nodes.videoData.video.duration',
              },
              {
                path: 'experience.configuration.displayInfo.richContent.nodes.videoData.thumbnail.duration',
              },
              {
                path: 'experience.configuration.displayInfo.richContent.nodes.audioData.audio.duration',
              },
              {
                path: 'experience.configuration.displayInfo.richContent.nodes.audioData.coverImage.duration',
              },
              {
                path: 'experience.configuration.displayInfo.richContent.nodes.layoutData.backgroundImage.media.duration',
              },
              {
                path: 'experience.configuration.displayInfo.richContent.nodes.layoutData.backdropImage.media.duration',
              },
              {
                path: 'experience.configuration.displayInfo.richContent.nodes.layoutData.background.gradient.centerX',
              },
              {
                path: 'experience.configuration.displayInfo.richContent.nodes.layoutData.background.gradient.centerY',
              },
              {
                path: 'experience.configuration.displayInfo.richContent.nodes.layoutData.background.gradient.stops.position',
              },
              {
                path: 'experience.configuration.displayInfo.richContent.nodes.layoutData.backdrop.gradient.centerX',
              },
              {
                path: 'experience.configuration.displayInfo.richContent.nodes.layoutData.backdrop.gradient.centerY',
              },
              {
                path: 'experience.configuration.displayInfo.richContent.nodes.layoutData.backdrop.gradient.stops.position',
              },
              {
                path: 'experience.configuration.displayInfo.richContent.nodes.shapeData.shape.duration',
              },
              {
                path: 'experience.configuration.displayInfo.richContent.nodes.cardData.background.gradient.centerX',
              },
              {
                path: 'experience.configuration.displayInfo.richContent.nodes.cardData.background.gradient.centerY',
              },
              {
                path: 'experience.configuration.displayInfo.richContent.nodes.cardData.background.gradient.stops.position',
              },
              {
                path: 'experience.configuration.displayInfo.richContent.nodes.cardData.backgroundImage.media.duration',
              },
              {
                path: 'experience.configuration.displayInfo.richContent.nodes.tocData.fontSize',
              },
              {
                path: 'experience.configuration.displayInfo.richContent.nodes.tocData.itemSpacing',
              },
              {
                path: 'experience.configuration.displayInfo.richContent.nodes.smartBlockCellData.shape.duration',
              },
            ],
          },
        ]),
    };

    return metadata;
  }

  return __createExperience;
}

/** Retrieves an experience. */
export function getExperience(payload: object): RequestOptionsFactory<any> {
  function __getExperience({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.table_reservations.v1.experience',
      method: 'GET' as any,
      methodFqn:
        'wix.table_reservations.experience.v1.ExperiencesService.GetExperience',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveWixTableReservationsExperienceV1ExperiencesServiceUrl({
        protoPath: '/v1/experiences/{experienceId}',
        data: payload,
        host,
      }),
      params: toURLSearchParams(payload),
      transformResponse: (payload: any) =>
        transformPaths(payload, [
          {
            transformFn: transformRESTTimestampToSDKTimestamp,
            paths: [
              { path: 'experience.createdDate' },
              { path: 'experience.updatedDate' },
              {
                path: 'experience.configuration.displayInfo.richContent.metadata.createdTimestamp',
              },
              {
                path: 'experience.configuration.displayInfo.richContent.metadata.updatedTimestamp',
              },
            ],
          },
          {
            transformFn: transformRESTFloatToSDKFloat,
            paths: [
              {
                path: 'experience.configuration.displayInfo.richContent.nodes.buttonData.styles.background.gradient.centerX',
              },
              {
                path: 'experience.configuration.displayInfo.richContent.nodes.buttonData.styles.background.gradient.centerY',
              },
              {
                path: 'experience.configuration.displayInfo.richContent.nodes.buttonData.styles.background.gradient.stops.position',
              },
              {
                path: 'experience.configuration.displayInfo.richContent.nodes.buttonData.styles.backgroundHover.gradient.centerX',
              },
              {
                path: 'experience.configuration.displayInfo.richContent.nodes.buttonData.styles.backgroundHover.gradient.centerY',
              },
              {
                path: 'experience.configuration.displayInfo.richContent.nodes.buttonData.styles.backgroundHover.gradient.stops.position',
              },
              {
                path: 'experience.configuration.displayInfo.richContent.nodes.galleryData.items.image.media.duration',
              },
              {
                path: 'experience.configuration.displayInfo.richContent.nodes.galleryData.items.video.media.duration',
              },
              {
                path: 'experience.configuration.displayInfo.richContent.nodes.galleryData.items.video.thumbnail.duration',
              },
              {
                path: 'experience.configuration.displayInfo.richContent.nodes.galleryData.options.item.ratio',
              },
              {
                path: 'experience.configuration.displayInfo.richContent.nodes.imageData.image.duration',
              },
              {
                path: 'experience.configuration.displayInfo.richContent.nodes.mapData.mapSettings.lat',
              },
              {
                path: 'experience.configuration.displayInfo.richContent.nodes.mapData.mapSettings.lng',
              },
              {
                path: 'experience.configuration.displayInfo.richContent.nodes.pollData.poll.image.duration',
              },
              {
                path: 'experience.configuration.displayInfo.richContent.nodes.pollData.poll.options.image.duration',
              },
              {
                path: 'experience.configuration.displayInfo.richContent.nodes.pollData.design.poll.background.image.duration',
              },
              {
                path: 'experience.configuration.displayInfo.richContent.nodes.appEmbedData.image.duration',
              },
              {
                path: 'experience.configuration.displayInfo.richContent.nodes.videoData.video.duration',
              },
              {
                path: 'experience.configuration.displayInfo.richContent.nodes.videoData.thumbnail.duration',
              },
              {
                path: 'experience.configuration.displayInfo.richContent.nodes.audioData.audio.duration',
              },
              {
                path: 'experience.configuration.displayInfo.richContent.nodes.audioData.coverImage.duration',
              },
              {
                path: 'experience.configuration.displayInfo.richContent.nodes.layoutData.backgroundImage.media.duration',
              },
              {
                path: 'experience.configuration.displayInfo.richContent.nodes.layoutData.backdropImage.media.duration',
              },
              {
                path: 'experience.configuration.displayInfo.richContent.nodes.layoutData.background.gradient.centerX',
              },
              {
                path: 'experience.configuration.displayInfo.richContent.nodes.layoutData.background.gradient.centerY',
              },
              {
                path: 'experience.configuration.displayInfo.richContent.nodes.layoutData.background.gradient.stops.position',
              },
              {
                path: 'experience.configuration.displayInfo.richContent.nodes.layoutData.backdrop.gradient.centerX',
              },
              {
                path: 'experience.configuration.displayInfo.richContent.nodes.layoutData.backdrop.gradient.centerY',
              },
              {
                path: 'experience.configuration.displayInfo.richContent.nodes.layoutData.backdrop.gradient.stops.position',
              },
              {
                path: 'experience.configuration.displayInfo.richContent.nodes.shapeData.shape.duration',
              },
              {
                path: 'experience.configuration.displayInfo.richContent.nodes.cardData.background.gradient.centerX',
              },
              {
                path: 'experience.configuration.displayInfo.richContent.nodes.cardData.background.gradient.centerY',
              },
              {
                path: 'experience.configuration.displayInfo.richContent.nodes.cardData.background.gradient.stops.position',
              },
              {
                path: 'experience.configuration.displayInfo.richContent.nodes.cardData.backgroundImage.media.duration',
              },
              {
                path: 'experience.configuration.displayInfo.richContent.nodes.tocData.fontSize',
              },
              {
                path: 'experience.configuration.displayInfo.richContent.nodes.tocData.itemSpacing',
              },
              {
                path: 'experience.configuration.displayInfo.richContent.nodes.smartBlockCellData.shape.duration',
              },
            ],
          },
        ]),
    };

    return metadata;
  }

  return __getExperience;
}

/**
 * Retrieves an experience by slug.
 *
 * The slug is a URL-friendly identifier for the experience page, derived from the experience display name in kebab-case format. For example, "wine-tasting-event".
 */
export function getExperienceBySlug(
  payload: object
): RequestOptionsFactory<any> {
  function __getExperienceBySlug({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.table_reservations.v1.experience',
      method: 'GET' as any,
      methodFqn:
        'wix.table_reservations.experience.v1.ExperiencesService.GetExperienceBySlug',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveWixTableReservationsExperienceV1ExperiencesServiceUrl({
        protoPath: '/v1/experiences/slug/{slug}',
        data: payload,
        host,
      }),
      params: toURLSearchParams(payload),
      transformResponse: (payload: any) =>
        transformPaths(payload, [
          {
            transformFn: transformRESTTimestampToSDKTimestamp,
            paths: [
              { path: 'experience.createdDate' },
              { path: 'experience.updatedDate' },
              {
                path: 'experience.configuration.displayInfo.richContent.metadata.createdTimestamp',
              },
              {
                path: 'experience.configuration.displayInfo.richContent.metadata.updatedTimestamp',
              },
            ],
          },
          {
            transformFn: transformRESTFloatToSDKFloat,
            paths: [
              {
                path: 'experience.configuration.displayInfo.richContent.nodes.buttonData.styles.background.gradient.centerX',
              },
              {
                path: 'experience.configuration.displayInfo.richContent.nodes.buttonData.styles.background.gradient.centerY',
              },
              {
                path: 'experience.configuration.displayInfo.richContent.nodes.buttonData.styles.background.gradient.stops.position',
              },
              {
                path: 'experience.configuration.displayInfo.richContent.nodes.buttonData.styles.backgroundHover.gradient.centerX',
              },
              {
                path: 'experience.configuration.displayInfo.richContent.nodes.buttonData.styles.backgroundHover.gradient.centerY',
              },
              {
                path: 'experience.configuration.displayInfo.richContent.nodes.buttonData.styles.backgroundHover.gradient.stops.position',
              },
              {
                path: 'experience.configuration.displayInfo.richContent.nodes.galleryData.items.image.media.duration',
              },
              {
                path: 'experience.configuration.displayInfo.richContent.nodes.galleryData.items.video.media.duration',
              },
              {
                path: 'experience.configuration.displayInfo.richContent.nodes.galleryData.items.video.thumbnail.duration',
              },
              {
                path: 'experience.configuration.displayInfo.richContent.nodes.galleryData.options.item.ratio',
              },
              {
                path: 'experience.configuration.displayInfo.richContent.nodes.imageData.image.duration',
              },
              {
                path: 'experience.configuration.displayInfo.richContent.nodes.mapData.mapSettings.lat',
              },
              {
                path: 'experience.configuration.displayInfo.richContent.nodes.mapData.mapSettings.lng',
              },
              {
                path: 'experience.configuration.displayInfo.richContent.nodes.pollData.poll.image.duration',
              },
              {
                path: 'experience.configuration.displayInfo.richContent.nodes.pollData.poll.options.image.duration',
              },
              {
                path: 'experience.configuration.displayInfo.richContent.nodes.pollData.design.poll.background.image.duration',
              },
              {
                path: 'experience.configuration.displayInfo.richContent.nodes.appEmbedData.image.duration',
              },
              {
                path: 'experience.configuration.displayInfo.richContent.nodes.videoData.video.duration',
              },
              {
                path: 'experience.configuration.displayInfo.richContent.nodes.videoData.thumbnail.duration',
              },
              {
                path: 'experience.configuration.displayInfo.richContent.nodes.audioData.audio.duration',
              },
              {
                path: 'experience.configuration.displayInfo.richContent.nodes.audioData.coverImage.duration',
              },
              {
                path: 'experience.configuration.displayInfo.richContent.nodes.layoutData.backgroundImage.media.duration',
              },
              {
                path: 'experience.configuration.displayInfo.richContent.nodes.layoutData.backdropImage.media.duration',
              },
              {
                path: 'experience.configuration.displayInfo.richContent.nodes.layoutData.background.gradient.centerX',
              },
              {
                path: 'experience.configuration.displayInfo.richContent.nodes.layoutData.background.gradient.centerY',
              },
              {
                path: 'experience.configuration.displayInfo.richContent.nodes.layoutData.background.gradient.stops.position',
              },
              {
                path: 'experience.configuration.displayInfo.richContent.nodes.layoutData.backdrop.gradient.centerX',
              },
              {
                path: 'experience.configuration.displayInfo.richContent.nodes.layoutData.backdrop.gradient.centerY',
              },
              {
                path: 'experience.configuration.displayInfo.richContent.nodes.layoutData.backdrop.gradient.stops.position',
              },
              {
                path: 'experience.configuration.displayInfo.richContent.nodes.shapeData.shape.duration',
              },
              {
                path: 'experience.configuration.displayInfo.richContent.nodes.cardData.background.gradient.centerX',
              },
              {
                path: 'experience.configuration.displayInfo.richContent.nodes.cardData.background.gradient.centerY',
              },
              {
                path: 'experience.configuration.displayInfo.richContent.nodes.cardData.background.gradient.stops.position',
              },
              {
                path: 'experience.configuration.displayInfo.richContent.nodes.cardData.backgroundImage.media.duration',
              },
              {
                path: 'experience.configuration.displayInfo.richContent.nodes.tocData.fontSize',
              },
              {
                path: 'experience.configuration.displayInfo.richContent.nodes.tocData.itemSpacing',
              },
              {
                path: 'experience.configuration.displayInfo.richContent.nodes.smartBlockCellData.shape.duration',
              },
            ],
          },
        ]),
    };

    return metadata;
  }

  return __getExperienceBySlug;
}

/**
 * Updates an experience.
 *
 * Each time the experience is updated, `revision` increments by 1.
 * The current `revision` must be passed when updating the experience.
 * This ensures you're working with the latest experience information and prevents unintended overwrites.
 *
 * To update multiple experiences in a single request, call [Bulk Update Experiences](https://dev.wix.com/docs/api-reference/business-solutions/restaurants/reservations/experiences/bulk-update-experiences).
 */
export function updateExperience(payload: object): RequestOptionsFactory<any> {
  function __updateExperience({ host }: any) {
    const serializedData = transformPaths(payload, [
      {
        transformFn: transformSDKFieldMaskToRESTFieldMask,
        paths: [{ path: 'fieldMask' }],
      },
      {
        transformFn: transformSDKTimestampToRESTTimestamp,
        paths: [
          { path: 'experience.createdDate' },
          { path: 'experience.updatedDate' },
          {
            path: 'experience.configuration.displayInfo.richContent.metadata.createdTimestamp',
          },
          {
            path: 'experience.configuration.displayInfo.richContent.metadata.updatedTimestamp',
          },
        ],
      },
      {
        transformFn: transformSDKFloatToRESTFloat,
        paths: [
          {
            path: 'experience.configuration.displayInfo.richContent.nodes.buttonData.styles.background.gradient.centerX',
          },
          {
            path: 'experience.configuration.displayInfo.richContent.nodes.buttonData.styles.background.gradient.centerY',
          },
          {
            path: 'experience.configuration.displayInfo.richContent.nodes.buttonData.styles.background.gradient.stops.position',
          },
          {
            path: 'experience.configuration.displayInfo.richContent.nodes.buttonData.styles.backgroundHover.gradient.centerX',
          },
          {
            path: 'experience.configuration.displayInfo.richContent.nodes.buttonData.styles.backgroundHover.gradient.centerY',
          },
          {
            path: 'experience.configuration.displayInfo.richContent.nodes.buttonData.styles.backgroundHover.gradient.stops.position',
          },
          {
            path: 'experience.configuration.displayInfo.richContent.nodes.galleryData.items.image.media.duration',
          },
          {
            path: 'experience.configuration.displayInfo.richContent.nodes.galleryData.items.video.media.duration',
          },
          {
            path: 'experience.configuration.displayInfo.richContent.nodes.galleryData.items.video.thumbnail.duration',
          },
          {
            path: 'experience.configuration.displayInfo.richContent.nodes.galleryData.options.item.ratio',
          },
          {
            path: 'experience.configuration.displayInfo.richContent.nodes.imageData.image.duration',
          },
          {
            path: 'experience.configuration.displayInfo.richContent.nodes.mapData.mapSettings.lat',
          },
          {
            path: 'experience.configuration.displayInfo.richContent.nodes.mapData.mapSettings.lng',
          },
          {
            path: 'experience.configuration.displayInfo.richContent.nodes.pollData.poll.image.duration',
          },
          {
            path: 'experience.configuration.displayInfo.richContent.nodes.pollData.poll.options.image.duration',
          },
          {
            path: 'experience.configuration.displayInfo.richContent.nodes.pollData.design.poll.background.image.duration',
          },
          {
            path: 'experience.configuration.displayInfo.richContent.nodes.appEmbedData.image.duration',
          },
          {
            path: 'experience.configuration.displayInfo.richContent.nodes.videoData.video.duration',
          },
          {
            path: 'experience.configuration.displayInfo.richContent.nodes.videoData.thumbnail.duration',
          },
          {
            path: 'experience.configuration.displayInfo.richContent.nodes.audioData.audio.duration',
          },
          {
            path: 'experience.configuration.displayInfo.richContent.nodes.audioData.coverImage.duration',
          },
          {
            path: 'experience.configuration.displayInfo.richContent.nodes.layoutData.backgroundImage.media.duration',
          },
          {
            path: 'experience.configuration.displayInfo.richContent.nodes.layoutData.backdropImage.media.duration',
          },
          {
            path: 'experience.configuration.displayInfo.richContent.nodes.layoutData.background.gradient.centerX',
          },
          {
            path: 'experience.configuration.displayInfo.richContent.nodes.layoutData.background.gradient.centerY',
          },
          {
            path: 'experience.configuration.displayInfo.richContent.nodes.layoutData.background.gradient.stops.position',
          },
          {
            path: 'experience.configuration.displayInfo.richContent.nodes.layoutData.backdrop.gradient.centerX',
          },
          {
            path: 'experience.configuration.displayInfo.richContent.nodes.layoutData.backdrop.gradient.centerY',
          },
          {
            path: 'experience.configuration.displayInfo.richContent.nodes.layoutData.backdrop.gradient.stops.position',
          },
          {
            path: 'experience.configuration.displayInfo.richContent.nodes.shapeData.shape.duration',
          },
          {
            path: 'experience.configuration.displayInfo.richContent.nodes.cardData.background.gradient.centerX',
          },
          {
            path: 'experience.configuration.displayInfo.richContent.nodes.cardData.background.gradient.centerY',
          },
          {
            path: 'experience.configuration.displayInfo.richContent.nodes.cardData.background.gradient.stops.position',
          },
          {
            path: 'experience.configuration.displayInfo.richContent.nodes.cardData.backgroundImage.media.duration',
          },
          {
            path: 'experience.configuration.displayInfo.richContent.nodes.tocData.fontSize',
          },
          {
            path: 'experience.configuration.displayInfo.richContent.nodes.tocData.itemSpacing',
          },
          {
            path: 'experience.configuration.displayInfo.richContent.nodes.smartBlockCellData.shape.duration',
          },
        ],
      },
    ]);
    const metadata = {
      entityFqdn: 'wix.table_reservations.v1.experience',
      method: 'PATCH' as any,
      methodFqn:
        'wix.table_reservations.experience.v1.ExperiencesService.UpdateExperience',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveWixTableReservationsExperienceV1ExperiencesServiceUrl({
        protoPath: '/v1/experiences/{experience.id}',
        data: serializedData,
        host,
      }),
      data: serializedData,
      transformResponse: (payload: any) =>
        transformPaths(payload, [
          {
            transformFn: transformRESTTimestampToSDKTimestamp,
            paths: [
              { path: 'experience.createdDate' },
              { path: 'experience.updatedDate' },
              {
                path: 'experience.configuration.displayInfo.richContent.metadata.createdTimestamp',
              },
              {
                path: 'experience.configuration.displayInfo.richContent.metadata.updatedTimestamp',
              },
            ],
          },
          {
            transformFn: transformRESTFloatToSDKFloat,
            paths: [
              {
                path: 'experience.configuration.displayInfo.richContent.nodes.buttonData.styles.background.gradient.centerX',
              },
              {
                path: 'experience.configuration.displayInfo.richContent.nodes.buttonData.styles.background.gradient.centerY',
              },
              {
                path: 'experience.configuration.displayInfo.richContent.nodes.buttonData.styles.background.gradient.stops.position',
              },
              {
                path: 'experience.configuration.displayInfo.richContent.nodes.buttonData.styles.backgroundHover.gradient.centerX',
              },
              {
                path: 'experience.configuration.displayInfo.richContent.nodes.buttonData.styles.backgroundHover.gradient.centerY',
              },
              {
                path: 'experience.configuration.displayInfo.richContent.nodes.buttonData.styles.backgroundHover.gradient.stops.position',
              },
              {
                path: 'experience.configuration.displayInfo.richContent.nodes.galleryData.items.image.media.duration',
              },
              {
                path: 'experience.configuration.displayInfo.richContent.nodes.galleryData.items.video.media.duration',
              },
              {
                path: 'experience.configuration.displayInfo.richContent.nodes.galleryData.items.video.thumbnail.duration',
              },
              {
                path: 'experience.configuration.displayInfo.richContent.nodes.galleryData.options.item.ratio',
              },
              {
                path: 'experience.configuration.displayInfo.richContent.nodes.imageData.image.duration',
              },
              {
                path: 'experience.configuration.displayInfo.richContent.nodes.mapData.mapSettings.lat',
              },
              {
                path: 'experience.configuration.displayInfo.richContent.nodes.mapData.mapSettings.lng',
              },
              {
                path: 'experience.configuration.displayInfo.richContent.nodes.pollData.poll.image.duration',
              },
              {
                path: 'experience.configuration.displayInfo.richContent.nodes.pollData.poll.options.image.duration',
              },
              {
                path: 'experience.configuration.displayInfo.richContent.nodes.pollData.design.poll.background.image.duration',
              },
              {
                path: 'experience.configuration.displayInfo.richContent.nodes.appEmbedData.image.duration',
              },
              {
                path: 'experience.configuration.displayInfo.richContent.nodes.videoData.video.duration',
              },
              {
                path: 'experience.configuration.displayInfo.richContent.nodes.videoData.thumbnail.duration',
              },
              {
                path: 'experience.configuration.displayInfo.richContent.nodes.audioData.audio.duration',
              },
              {
                path: 'experience.configuration.displayInfo.richContent.nodes.audioData.coverImage.duration',
              },
              {
                path: 'experience.configuration.displayInfo.richContent.nodes.layoutData.backgroundImage.media.duration',
              },
              {
                path: 'experience.configuration.displayInfo.richContent.nodes.layoutData.backdropImage.media.duration',
              },
              {
                path: 'experience.configuration.displayInfo.richContent.nodes.layoutData.background.gradient.centerX',
              },
              {
                path: 'experience.configuration.displayInfo.richContent.nodes.layoutData.background.gradient.centerY',
              },
              {
                path: 'experience.configuration.displayInfo.richContent.nodes.layoutData.background.gradient.stops.position',
              },
              {
                path: 'experience.configuration.displayInfo.richContent.nodes.layoutData.backdrop.gradient.centerX',
              },
              {
                path: 'experience.configuration.displayInfo.richContent.nodes.layoutData.backdrop.gradient.centerY',
              },
              {
                path: 'experience.configuration.displayInfo.richContent.nodes.layoutData.backdrop.gradient.stops.position',
              },
              {
                path: 'experience.configuration.displayInfo.richContent.nodes.shapeData.shape.duration',
              },
              {
                path: 'experience.configuration.displayInfo.richContent.nodes.cardData.background.gradient.centerX',
              },
              {
                path: 'experience.configuration.displayInfo.richContent.nodes.cardData.background.gradient.centerY',
              },
              {
                path: 'experience.configuration.displayInfo.richContent.nodes.cardData.background.gradient.stops.position',
              },
              {
                path: 'experience.configuration.displayInfo.richContent.nodes.cardData.backgroundImage.media.duration',
              },
              {
                path: 'experience.configuration.displayInfo.richContent.nodes.tocData.fontSize',
              },
              {
                path: 'experience.configuration.displayInfo.richContent.nodes.tocData.itemSpacing',
              },
              {
                path: 'experience.configuration.displayInfo.richContent.nodes.smartBlockCellData.shape.duration',
              },
            ],
          },
        ]),
    };

    return metadata;
  }

  return __updateExperience;
}

/**
 * Retrieves a list of experiences using the specified paging, filtering, and sorting.
 *
 * For a detailed list of supported operations, see the [Supported Filters and Sorting](https://dev.wix.com/docs/api-reference/business-solutions/restaurants/reservations/experiences/sorting-and-filtering) article.
 * To learn how to query reservation locations, see [API Query Language](https://dev.wix.com/docs/api-reference/articles/work-with-wix-apis/data-retrieval/about-the-wix-api-query-language).
 */
export function queryExperiences(payload: object): RequestOptionsFactory<any> {
  function __queryExperiences({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.table_reservations.v1.experience',
      method: 'GET' as any,
      methodFqn:
        'wix.table_reservations.experience.v1.ExperiencesService.QueryExperiences',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveWixTableReservationsExperienceV1ExperiencesServiceUrl({
        protoPath: '/v1/experiences/query',
        data: payload,
        host,
      }),
      params: toURLSearchParams(payload, true),
      transformResponse: (payload: any) =>
        transformPaths(payload, [
          {
            transformFn: transformRESTTimestampToSDKTimestamp,
            paths: [
              { path: 'experiences.createdDate' },
              { path: 'experiences.updatedDate' },
              {
                path: 'experiences.configuration.displayInfo.richContent.metadata.createdTimestamp',
              },
              {
                path: 'experiences.configuration.displayInfo.richContent.metadata.updatedTimestamp',
              },
            ],
          },
          {
            transformFn: transformRESTFloatToSDKFloat,
            paths: [
              {
                path: 'experiences.configuration.displayInfo.richContent.nodes.buttonData.styles.background.gradient.centerX',
              },
              {
                path: 'experiences.configuration.displayInfo.richContent.nodes.buttonData.styles.background.gradient.centerY',
              },
              {
                path: 'experiences.configuration.displayInfo.richContent.nodes.buttonData.styles.background.gradient.stops.position',
              },
              {
                path: 'experiences.configuration.displayInfo.richContent.nodes.buttonData.styles.backgroundHover.gradient.centerX',
              },
              {
                path: 'experiences.configuration.displayInfo.richContent.nodes.buttonData.styles.backgroundHover.gradient.centerY',
              },
              {
                path: 'experiences.configuration.displayInfo.richContent.nodes.buttonData.styles.backgroundHover.gradient.stops.position',
              },
              {
                path: 'experiences.configuration.displayInfo.richContent.nodes.galleryData.items.image.media.duration',
              },
              {
                path: 'experiences.configuration.displayInfo.richContent.nodes.galleryData.items.video.media.duration',
              },
              {
                path: 'experiences.configuration.displayInfo.richContent.nodes.galleryData.items.video.thumbnail.duration',
              },
              {
                path: 'experiences.configuration.displayInfo.richContent.nodes.galleryData.options.item.ratio',
              },
              {
                path: 'experiences.configuration.displayInfo.richContent.nodes.imageData.image.duration',
              },
              {
                path: 'experiences.configuration.displayInfo.richContent.nodes.mapData.mapSettings.lat',
              },
              {
                path: 'experiences.configuration.displayInfo.richContent.nodes.mapData.mapSettings.lng',
              },
              {
                path: 'experiences.configuration.displayInfo.richContent.nodes.pollData.poll.image.duration',
              },
              {
                path: 'experiences.configuration.displayInfo.richContent.nodes.pollData.poll.options.image.duration',
              },
              {
                path: 'experiences.configuration.displayInfo.richContent.nodes.pollData.design.poll.background.image.duration',
              },
              {
                path: 'experiences.configuration.displayInfo.richContent.nodes.appEmbedData.image.duration',
              },
              {
                path: 'experiences.configuration.displayInfo.richContent.nodes.videoData.video.duration',
              },
              {
                path: 'experiences.configuration.displayInfo.richContent.nodes.videoData.thumbnail.duration',
              },
              {
                path: 'experiences.configuration.displayInfo.richContent.nodes.audioData.audio.duration',
              },
              {
                path: 'experiences.configuration.displayInfo.richContent.nodes.audioData.coverImage.duration',
              },
              {
                path: 'experiences.configuration.displayInfo.richContent.nodes.layoutData.backgroundImage.media.duration',
              },
              {
                path: 'experiences.configuration.displayInfo.richContent.nodes.layoutData.backdropImage.media.duration',
              },
              {
                path: 'experiences.configuration.displayInfo.richContent.nodes.layoutData.background.gradient.centerX',
              },
              {
                path: 'experiences.configuration.displayInfo.richContent.nodes.layoutData.background.gradient.centerY',
              },
              {
                path: 'experiences.configuration.displayInfo.richContent.nodes.layoutData.background.gradient.stops.position',
              },
              {
                path: 'experiences.configuration.displayInfo.richContent.nodes.layoutData.backdrop.gradient.centerX',
              },
              {
                path: 'experiences.configuration.displayInfo.richContent.nodes.layoutData.backdrop.gradient.centerY',
              },
              {
                path: 'experiences.configuration.displayInfo.richContent.nodes.layoutData.backdrop.gradient.stops.position',
              },
              {
                path: 'experiences.configuration.displayInfo.richContent.nodes.shapeData.shape.duration',
              },
              {
                path: 'experiences.configuration.displayInfo.richContent.nodes.cardData.background.gradient.centerX',
              },
              {
                path: 'experiences.configuration.displayInfo.richContent.nodes.cardData.background.gradient.centerY',
              },
              {
                path: 'experiences.configuration.displayInfo.richContent.nodes.cardData.background.gradient.stops.position',
              },
              {
                path: 'experiences.configuration.displayInfo.richContent.nodes.cardData.backgroundImage.media.duration',
              },
              {
                path: 'experiences.configuration.displayInfo.richContent.nodes.tocData.fontSize',
              },
              {
                path: 'experiences.configuration.displayInfo.richContent.nodes.tocData.itemSpacing',
              },
              {
                path: 'experiences.configuration.displayInfo.richContent.nodes.smartBlockCellData.shape.duration',
              },
            ],
          },
        ]),
      fallback: [
        {
          method: 'POST' as any,
          url: resolveWixTableReservationsExperienceV1ExperiencesServiceUrl({
            protoPath: '/v1/experiences/query',
            data: payload,
            host,
          }),
          data: payload,
        },
      ],
    };

    return metadata;
  }

  return __queryExperiences;
}

/**
 * Use this method to search the fields of the experiences on a site for a given expression.
 *
 * You can also use this method to perform data aggregations on a site's experience fields.
 */
export function searchExperiences(payload: object): RequestOptionsFactory<any> {
  function __searchExperiences({ host }: any) {
    const serializedData = transformPaths(payload, [
      {
        transformFn: transformSDKFloatToRESTFloat,
        paths: [
          { path: 'search.aggregations.range.buckets.from' },
          { path: 'search.aggregations.range.buckets.to' },
          {
            path: 'search.aggregations.nested.nestedAggregations.range.buckets.from',
          },
          {
            path: 'search.aggregations.nested.nestedAggregations.range.buckets.to',
          },
        ],
      },
    ]);
    const metadata = {
      entityFqdn: 'wix.table_reservations.v1.experience',
      method: 'GET' as any,
      methodFqn:
        'wix.table_reservations.experience.v1.ExperiencesService.SearchExperiences',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveWixTableReservationsExperienceV1ExperiencesServiceUrl({
        protoPath: '/v1/experiences/search',
        data: serializedData,
        host,
      }),
      params: toURLSearchParams(serializedData, true),
      transformResponse: (payload: any) =>
        transformPaths(payload, [
          {
            transformFn: transformRESTTimestampToSDKTimestamp,
            paths: [
              { path: 'experiences.createdDate' },
              { path: 'experiences.updatedDate' },
              {
                path: 'experiences.configuration.displayInfo.richContent.metadata.createdTimestamp',
              },
              {
                path: 'experiences.configuration.displayInfo.richContent.metadata.updatedTimestamp',
              },
            ],
          },
          {
            transformFn: transformRESTFloatToSDKFloat,
            paths: [
              {
                path: 'experiences.configuration.displayInfo.richContent.nodes.buttonData.styles.background.gradient.centerX',
              },
              {
                path: 'experiences.configuration.displayInfo.richContent.nodes.buttonData.styles.background.gradient.centerY',
              },
              {
                path: 'experiences.configuration.displayInfo.richContent.nodes.buttonData.styles.background.gradient.stops.position',
              },
              {
                path: 'experiences.configuration.displayInfo.richContent.nodes.buttonData.styles.backgroundHover.gradient.centerX',
              },
              {
                path: 'experiences.configuration.displayInfo.richContent.nodes.buttonData.styles.backgroundHover.gradient.centerY',
              },
              {
                path: 'experiences.configuration.displayInfo.richContent.nodes.buttonData.styles.backgroundHover.gradient.stops.position',
              },
              {
                path: 'experiences.configuration.displayInfo.richContent.nodes.galleryData.items.image.media.duration',
              },
              {
                path: 'experiences.configuration.displayInfo.richContent.nodes.galleryData.items.video.media.duration',
              },
              {
                path: 'experiences.configuration.displayInfo.richContent.nodes.galleryData.items.video.thumbnail.duration',
              },
              {
                path: 'experiences.configuration.displayInfo.richContent.nodes.galleryData.options.item.ratio',
              },
              {
                path: 'experiences.configuration.displayInfo.richContent.nodes.imageData.image.duration',
              },
              {
                path: 'experiences.configuration.displayInfo.richContent.nodes.mapData.mapSettings.lat',
              },
              {
                path: 'experiences.configuration.displayInfo.richContent.nodes.mapData.mapSettings.lng',
              },
              {
                path: 'experiences.configuration.displayInfo.richContent.nodes.pollData.poll.image.duration',
              },
              {
                path: 'experiences.configuration.displayInfo.richContent.nodes.pollData.poll.options.image.duration',
              },
              {
                path: 'experiences.configuration.displayInfo.richContent.nodes.pollData.design.poll.background.image.duration',
              },
              {
                path: 'experiences.configuration.displayInfo.richContent.nodes.appEmbedData.image.duration',
              },
              {
                path: 'experiences.configuration.displayInfo.richContent.nodes.videoData.video.duration',
              },
              {
                path: 'experiences.configuration.displayInfo.richContent.nodes.videoData.thumbnail.duration',
              },
              {
                path: 'experiences.configuration.displayInfo.richContent.nodes.audioData.audio.duration',
              },
              {
                path: 'experiences.configuration.displayInfo.richContent.nodes.audioData.coverImage.duration',
              },
              {
                path: 'experiences.configuration.displayInfo.richContent.nodes.layoutData.backgroundImage.media.duration',
              },
              {
                path: 'experiences.configuration.displayInfo.richContent.nodes.layoutData.backdropImage.media.duration',
              },
              {
                path: 'experiences.configuration.displayInfo.richContent.nodes.layoutData.background.gradient.centerX',
              },
              {
                path: 'experiences.configuration.displayInfo.richContent.nodes.layoutData.background.gradient.centerY',
              },
              {
                path: 'experiences.configuration.displayInfo.richContent.nodes.layoutData.background.gradient.stops.position',
              },
              {
                path: 'experiences.configuration.displayInfo.richContent.nodes.layoutData.backdrop.gradient.centerX',
              },
              {
                path: 'experiences.configuration.displayInfo.richContent.nodes.layoutData.backdrop.gradient.centerY',
              },
              {
                path: 'experiences.configuration.displayInfo.richContent.nodes.layoutData.backdrop.gradient.stops.position',
              },
              {
                path: 'experiences.configuration.displayInfo.richContent.nodes.shapeData.shape.duration',
              },
              {
                path: 'experiences.configuration.displayInfo.richContent.nodes.cardData.background.gradient.centerX',
              },
              {
                path: 'experiences.configuration.displayInfo.richContent.nodes.cardData.background.gradient.centerY',
              },
              {
                path: 'experiences.configuration.displayInfo.richContent.nodes.cardData.background.gradient.stops.position',
              },
              {
                path: 'experiences.configuration.displayInfo.richContent.nodes.cardData.backgroundImage.media.duration',
              },
              {
                path: 'experiences.configuration.displayInfo.richContent.nodes.tocData.fontSize',
              },
              {
                path: 'experiences.configuration.displayInfo.richContent.nodes.tocData.itemSpacing',
              },
              {
                path: 'experiences.configuration.displayInfo.richContent.nodes.smartBlockCellData.shape.duration',
              },
              { path: 'aggregationData.results.ranges.results.from' },
              { path: 'aggregationData.results.ranges.results.to' },
              {
                path: 'aggregationData.results.groupedByValue.results.nestedResults.ranges.results.from',
              },
              {
                path: 'aggregationData.results.groupedByValue.results.nestedResults.ranges.results.to',
              },
              {
                path: 'aggregationData.results.nested.results.results.*.range.from',
              },
              {
                path: 'aggregationData.results.nested.results.results.*.range.to',
              },
              { path: 'aggregationData.results.scalar.value' },
              {
                path: 'aggregationData.results.groupedByValue.results.nestedResults.scalar.value',
              },
              {
                path: 'aggregationData.results.nested.results.results.*.scalar.value',
              },
            ],
          },
        ]),
      fallback: [
        {
          method: 'POST' as any,
          url: resolveWixTableReservationsExperienceV1ExperiencesServiceUrl({
            protoPath: '/v1/experiences/search',
            data: serializedData,
            host,
          }),
          data: serializedData,
        },
      ],
    };

    return metadata;
  }

  return __searchExperiences;
}

/**
 * Updates up to 100 experiences in a single request.
 *
 * Each experience is updated independently. If an update fails for one experience, the failure is reported in that experience's `itemMetadata.error` and the remaining experiences are still processed. The call returns successfully even when some updates fail.
 *
 * Set `returnEntity` to `true` to receive the updated experiences in the response.
 *
 * Archived experiences can't be updated.
 *
 * To update a single experience, call [Update Experience](https://dev.wix.com/docs/api-reference/business-solutions/restaurants/reservations/experiences/update-experience).
 */
export function bulkUpdateExperiences(
  payload: object
): RequestOptionsFactory<any> {
  function __bulkUpdateExperiences({ host }: any) {
    const serializedData = transformPaths(payload, [
      {
        transformFn: transformSDKFieldMaskToRESTFieldMask,
        paths: [{ path: 'experiences.fieldMask' }],
      },
      {
        transformFn: transformSDKTimestampToRESTTimestamp,
        paths: [
          { path: 'experiences.experience.createdDate' },
          { path: 'experiences.experience.updatedDate' },
          {
            path: 'experiences.experience.configuration.displayInfo.richContent.metadata.createdTimestamp',
          },
          {
            path: 'experiences.experience.configuration.displayInfo.richContent.metadata.updatedTimestamp',
          },
        ],
      },
      {
        transformFn: transformSDKFloatToRESTFloat,
        paths: [
          {
            path: 'experiences.experience.configuration.displayInfo.richContent.nodes.buttonData.styles.background.gradient.centerX',
          },
          {
            path: 'experiences.experience.configuration.displayInfo.richContent.nodes.buttonData.styles.background.gradient.centerY',
          },
          {
            path: 'experiences.experience.configuration.displayInfo.richContent.nodes.buttonData.styles.background.gradient.stops.position',
          },
          {
            path: 'experiences.experience.configuration.displayInfo.richContent.nodes.buttonData.styles.backgroundHover.gradient.centerX',
          },
          {
            path: 'experiences.experience.configuration.displayInfo.richContent.nodes.buttonData.styles.backgroundHover.gradient.centerY',
          },
          {
            path: 'experiences.experience.configuration.displayInfo.richContent.nodes.buttonData.styles.backgroundHover.gradient.stops.position',
          },
          {
            path: 'experiences.experience.configuration.displayInfo.richContent.nodes.galleryData.items.image.media.duration',
          },
          {
            path: 'experiences.experience.configuration.displayInfo.richContent.nodes.galleryData.items.video.media.duration',
          },
          {
            path: 'experiences.experience.configuration.displayInfo.richContent.nodes.galleryData.items.video.thumbnail.duration',
          },
          {
            path: 'experiences.experience.configuration.displayInfo.richContent.nodes.galleryData.options.item.ratio',
          },
          {
            path: 'experiences.experience.configuration.displayInfo.richContent.nodes.imageData.image.duration',
          },
          {
            path: 'experiences.experience.configuration.displayInfo.richContent.nodes.mapData.mapSettings.lat',
          },
          {
            path: 'experiences.experience.configuration.displayInfo.richContent.nodes.mapData.mapSettings.lng',
          },
          {
            path: 'experiences.experience.configuration.displayInfo.richContent.nodes.pollData.poll.image.duration',
          },
          {
            path: 'experiences.experience.configuration.displayInfo.richContent.nodes.pollData.poll.options.image.duration',
          },
          {
            path: 'experiences.experience.configuration.displayInfo.richContent.nodes.pollData.design.poll.background.image.duration',
          },
          {
            path: 'experiences.experience.configuration.displayInfo.richContent.nodes.appEmbedData.image.duration',
          },
          {
            path: 'experiences.experience.configuration.displayInfo.richContent.nodes.videoData.video.duration',
          },
          {
            path: 'experiences.experience.configuration.displayInfo.richContent.nodes.videoData.thumbnail.duration',
          },
          {
            path: 'experiences.experience.configuration.displayInfo.richContent.nodes.audioData.audio.duration',
          },
          {
            path: 'experiences.experience.configuration.displayInfo.richContent.nodes.audioData.coverImage.duration',
          },
          {
            path: 'experiences.experience.configuration.displayInfo.richContent.nodes.layoutData.backgroundImage.media.duration',
          },
          {
            path: 'experiences.experience.configuration.displayInfo.richContent.nodes.layoutData.backdropImage.media.duration',
          },
          {
            path: 'experiences.experience.configuration.displayInfo.richContent.nodes.layoutData.background.gradient.centerX',
          },
          {
            path: 'experiences.experience.configuration.displayInfo.richContent.nodes.layoutData.background.gradient.centerY',
          },
          {
            path: 'experiences.experience.configuration.displayInfo.richContent.nodes.layoutData.background.gradient.stops.position',
          },
          {
            path: 'experiences.experience.configuration.displayInfo.richContent.nodes.layoutData.backdrop.gradient.centerX',
          },
          {
            path: 'experiences.experience.configuration.displayInfo.richContent.nodes.layoutData.backdrop.gradient.centerY',
          },
          {
            path: 'experiences.experience.configuration.displayInfo.richContent.nodes.layoutData.backdrop.gradient.stops.position',
          },
          {
            path: 'experiences.experience.configuration.displayInfo.richContent.nodes.shapeData.shape.duration',
          },
          {
            path: 'experiences.experience.configuration.displayInfo.richContent.nodes.cardData.background.gradient.centerX',
          },
          {
            path: 'experiences.experience.configuration.displayInfo.richContent.nodes.cardData.background.gradient.centerY',
          },
          {
            path: 'experiences.experience.configuration.displayInfo.richContent.nodes.cardData.background.gradient.stops.position',
          },
          {
            path: 'experiences.experience.configuration.displayInfo.richContent.nodes.cardData.backgroundImage.media.duration',
          },
          {
            path: 'experiences.experience.configuration.displayInfo.richContent.nodes.tocData.fontSize',
          },
          {
            path: 'experiences.experience.configuration.displayInfo.richContent.nodes.tocData.itemSpacing',
          },
          {
            path: 'experiences.experience.configuration.displayInfo.richContent.nodes.smartBlockCellData.shape.duration',
          },
        ],
      },
    ]);
    const metadata = {
      entityFqdn: 'wix.table_reservations.v1.experience',
      method: 'POST' as any,
      methodFqn:
        'wix.table_reservations.experience.v1.ExperiencesService.BulkUpdateExperiences',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveWixTableReservationsExperienceV1ExperiencesServiceUrl({
        protoPath: '/v1/bulk/experiences/update',
        data: serializedData,
        host,
      }),
      data: serializedData,
      transformResponse: (payload: any) =>
        transformPaths(payload, [
          {
            transformFn: transformRESTTimestampToSDKTimestamp,
            paths: [
              { path: 'results.item.createdDate' },
              { path: 'results.item.updatedDate' },
              {
                path: 'results.item.configuration.displayInfo.richContent.metadata.createdTimestamp',
              },
              {
                path: 'results.item.configuration.displayInfo.richContent.metadata.updatedTimestamp',
              },
            ],
          },
          {
            transformFn: transformRESTFloatToSDKFloat,
            paths: [
              {
                path: 'results.item.configuration.displayInfo.richContent.nodes.buttonData.styles.background.gradient.centerX',
              },
              {
                path: 'results.item.configuration.displayInfo.richContent.nodes.buttonData.styles.background.gradient.centerY',
              },
              {
                path: 'results.item.configuration.displayInfo.richContent.nodes.buttonData.styles.background.gradient.stops.position',
              },
              {
                path: 'results.item.configuration.displayInfo.richContent.nodes.buttonData.styles.backgroundHover.gradient.centerX',
              },
              {
                path: 'results.item.configuration.displayInfo.richContent.nodes.buttonData.styles.backgroundHover.gradient.centerY',
              },
              {
                path: 'results.item.configuration.displayInfo.richContent.nodes.buttonData.styles.backgroundHover.gradient.stops.position',
              },
              {
                path: 'results.item.configuration.displayInfo.richContent.nodes.galleryData.items.image.media.duration',
              },
              {
                path: 'results.item.configuration.displayInfo.richContent.nodes.galleryData.items.video.media.duration',
              },
              {
                path: 'results.item.configuration.displayInfo.richContent.nodes.galleryData.items.video.thumbnail.duration',
              },
              {
                path: 'results.item.configuration.displayInfo.richContent.nodes.galleryData.options.item.ratio',
              },
              {
                path: 'results.item.configuration.displayInfo.richContent.nodes.imageData.image.duration',
              },
              {
                path: 'results.item.configuration.displayInfo.richContent.nodes.mapData.mapSettings.lat',
              },
              {
                path: 'results.item.configuration.displayInfo.richContent.nodes.mapData.mapSettings.lng',
              },
              {
                path: 'results.item.configuration.displayInfo.richContent.nodes.pollData.poll.image.duration',
              },
              {
                path: 'results.item.configuration.displayInfo.richContent.nodes.pollData.poll.options.image.duration',
              },
              {
                path: 'results.item.configuration.displayInfo.richContent.nodes.pollData.design.poll.background.image.duration',
              },
              {
                path: 'results.item.configuration.displayInfo.richContent.nodes.appEmbedData.image.duration',
              },
              {
                path: 'results.item.configuration.displayInfo.richContent.nodes.videoData.video.duration',
              },
              {
                path: 'results.item.configuration.displayInfo.richContent.nodes.videoData.thumbnail.duration',
              },
              {
                path: 'results.item.configuration.displayInfo.richContent.nodes.audioData.audio.duration',
              },
              {
                path: 'results.item.configuration.displayInfo.richContent.nodes.audioData.coverImage.duration',
              },
              {
                path: 'results.item.configuration.displayInfo.richContent.nodes.layoutData.backgroundImage.media.duration',
              },
              {
                path: 'results.item.configuration.displayInfo.richContent.nodes.layoutData.backdropImage.media.duration',
              },
              {
                path: 'results.item.configuration.displayInfo.richContent.nodes.layoutData.background.gradient.centerX',
              },
              {
                path: 'results.item.configuration.displayInfo.richContent.nodes.layoutData.background.gradient.centerY',
              },
              {
                path: 'results.item.configuration.displayInfo.richContent.nodes.layoutData.background.gradient.stops.position',
              },
              {
                path: 'results.item.configuration.displayInfo.richContent.nodes.layoutData.backdrop.gradient.centerX',
              },
              {
                path: 'results.item.configuration.displayInfo.richContent.nodes.layoutData.backdrop.gradient.centerY',
              },
              {
                path: 'results.item.configuration.displayInfo.richContent.nodes.layoutData.backdrop.gradient.stops.position',
              },
              {
                path: 'results.item.configuration.displayInfo.richContent.nodes.shapeData.shape.duration',
              },
              {
                path: 'results.item.configuration.displayInfo.richContent.nodes.cardData.background.gradient.centerX',
              },
              {
                path: 'results.item.configuration.displayInfo.richContent.nodes.cardData.background.gradient.centerY',
              },
              {
                path: 'results.item.configuration.displayInfo.richContent.nodes.cardData.background.gradient.stops.position',
              },
              {
                path: 'results.item.configuration.displayInfo.richContent.nodes.cardData.backgroundImage.media.duration',
              },
              {
                path: 'results.item.configuration.displayInfo.richContent.nodes.tocData.fontSize',
              },
              {
                path: 'results.item.configuration.displayInfo.richContent.nodes.tocData.itemSpacing',
              },
              {
                path: 'results.item.configuration.displayInfo.richContent.nodes.smartBlockCellData.shape.duration',
              },
            ],
          },
        ]),
    };

    return metadata;
  }

  return __bulkUpdateExperiences;
}

/** Synchronously updates [tags](https://dev.wix.com/docs/api-reference/business-management/tags/introduction) on multiple experiences by experience IDs. A tag that appears in both assign and unassign lists is assigned. */
export function bulkUpdateExperienceTags(
  payload: object
): RequestOptionsFactory<any> {
  function __bulkUpdateExperienceTags({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.table_reservations.v1.experience',
      method: 'POST' as any,
      methodFqn:
        'wix.table_reservations.experience.v1.ExperiencesService.BulkUpdateExperienceTags',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveWixTableReservationsExperienceV1ExperiencesServiceUrl({
        protoPath: '/v1/bulk/experiences/update-tags',
        data: payload,
        host,
      }),
      data: payload,
    };

    return metadata;
  }

  return __bulkUpdateExperienceTags;
}

/** Asynchronously updates [tags](https://dev.wix.com/docs/api-reference/business-management/tags/introduction) on multiple experiences using filter criteria. An empty filter updates all experiences. A tag that appears in both assign and unassign lists is assigned. */
export function bulkUpdateExperienceTagsByFilter(
  payload: object
): RequestOptionsFactory<any> {
  function __bulkUpdateExperienceTagsByFilter({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.table_reservations.v1.experience',
      method: 'POST' as any,
      methodFqn:
        'wix.table_reservations.experience.v1.ExperiencesService.BulkUpdateExperienceTagsByFilter',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveWixTableReservationsExperienceV1ExperiencesServiceUrl({
        protoPath: '/v1/bulk/experiences/update-tags-by-filter',
        data: payload,
        host,
      }),
      data: payload,
    };

    return metadata;
  }

  return __bulkUpdateExperienceTagsByFilter;
}

/**
 * Archives multiple experiences.
 *
 * Archiving an experience sets `configuration.visible` to `false`, preventing it from appearing on the live site and from accepting new reservations.
 *
 * To unarchive experiences, call [Bulk Unarchive Experiences](https://dev.wix.com/docs/api-reference/business-solutions/restaurants/reservations/experiences/bulk-unarchive-experiences).
 */
export function bulkArchiveExperiences(
  payload: object
): RequestOptionsFactory<any> {
  function __bulkArchiveExperiences({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.table_reservations.v1.experience',
      method: 'POST' as any,
      methodFqn:
        'wix.table_reservations.experience.v1.ExperiencesService.BulkArchiveExperiences',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveWixTableReservationsExperienceV1ExperiencesServiceUrl({
        protoPath: '/v1/bulk/experiences/archive',
        data: payload,
        host,
      }),
      data: payload,
    };

    return metadata;
  }

  return __bulkArchiveExperiences;
}

/**
 * Unarchives multiple experiences.
 *
 * Unarchiving an experience only sets the archived status to `false`. It doesn't restore `configuration.visible` to its previous state.
 * To make the experience appear on the live site again, call [Update Experience](https://dev.wix.com/docs/api-reference/business-solutions/restaurants/reservations/experiences/update-experience) to set `configuration.visible` to `true`.
 *
 * To archive experiences, call [Bulk Archive Experiences](https://dev.wix.com/docs/api-reference/business-solutions/restaurants/reservations/experiences/bulk-archive-experiences).
 */
export function bulkUnarchiveExperiences(
  payload: object
): RequestOptionsFactory<any> {
  function __bulkUnarchiveExperiences({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.table_reservations.v1.experience',
      method: 'POST' as any,
      methodFqn:
        'wix.table_reservations.experience.v1.ExperiencesService.BulkUnarchiveExperiences',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveWixTableReservationsExperienceV1ExperiencesServiceUrl({
        protoPath: '/v1/bulk/experiences/unarchive',
        data: payload,
        host,
      }),
      data: payload,
    };

    return metadata;
  }

  return __bulkUnarchiveExperiences;
}
